import React from 'react';
import PropTypes from 'prop-types';
import Editor from '@monaco-editor/react';
import './ScriptEditor.css';

const ScriptEditor = ({
  finalScript,
  setFinalScript,
  scriptLanguage,
  editorTheme,
  generatedScripts,
  currentScriptId,
  selectedTechnology
}) => (
  <div className="script-editor-container">
    <div className="editor-header">
      <h3>Generated {selectedTechnology} Transformation Scripts</h3>
      <div className="editor-controls">
        <div className="language-info">
          <span className="language-badge">{scriptLanguage.toUpperCase()}</span>
          <span className="technology-badge">{selectedTechnology}</span>
        </div>
        {finalScript && (
          <div className="script-stats">
            <span className="stat-item">
              📄 {finalScript.split('\n').length} lines
            </span>
            {/* <span className="stat-item">
              📦 {Object.keys(generatedScripts).length} batches
            </span> */}
            {currentScriptId && (
              <span className="stat-item">
                💾 Saved to History
              </span>
            )}
          </div>
        )}
      </div>
    </div>
    <div className="monaco-editor-container">
      <Editor
        height="100%"
        language={scriptLanguage}
        theme={editorTheme}
        value={finalScript}
        onChange={(value) => setFinalScript(value || '')}
        options={{
          minimap: { enabled: true },
          fontSize: 14,
          wordWrap: 'on',
          automaticLayout: true,
          scrollBeyondLastLine: false,
          readOnly: false,
          lineNumbers: 'on',
          folding: true,
          lineDecorationsWidth: 10,
          lineNumbersMinChars: 3,
          renderLineHighlight: 'all',
          cursorBlinking: 'smooth',
          cursorSmoothCaretAnimation: 'on',
        }}
      />
    </div>
  </div>
);

ScriptEditor.propTypes = {
  finalScript: PropTypes.string.isRequired,
  setFinalScript: PropTypes.func.isRequired,
  scriptLanguage: PropTypes.string.isRequired,
  editorTheme: PropTypes.string.isRequired,
  generatedScripts: PropTypes.object.isRequired,
  currentScriptId: PropTypes.string,
  selectedTechnology: PropTypes.string.isRequired
};

export default ScriptEditor; 